/* @flow */

export const replace = (values: string[], i18nString: string) => values.reduce((pre, cur) => pre.replace('##', cur), i18nString);
export const getLabel = (label: string, i18n:Object = {}, fallbackStr?: string): string => (
  i18n[label] || (fallbackStr || label)
);

export const getLabelWithDefaultStr = (url: string, locale: Object = {}, defaultStr: string): string => {
  const i18nStr = getLabel(url, locale, defaultStr);
  // NOTE:
  // If i18nStr === ' ', it means there are no translations available for that locale
  // from our i18n platform. (It could be thought of as a legacy bug.)
  return i18nStr !== ' ' ? i18nStr : defaultStr;
};
